import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-mediego-exit-confirmation-dialog',
    templateUrl: './exit-confirmation-dialog.component.html',
    styleUrls: ['./exit-confirmation-dialog.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExitConfirmationDialogComponent {}
